module.exports = __webpack_public_path__ + "static/media/LetterIdentifications.f696454e.svg";